































































import { Vue, Component } from "vue-property-decorator";
import ContItem from "@/components/home/contItem/ContItem.vue";
import ContItemTitle from "@/components/home/contItem/ContItem_Title.vue";
import ContItemContent from "@/components/home/contItem/ContItem_content.vue";
import BoxItem from "@/components/home/contItem/ContItem_Content_boxItem.vue";
import "@/components/al/ImportJs";

@Component({
    components: {
        "cont-item": ContItem,
        "cont-title-pro": ContItemTitle,
        "cont-content-box": ContItemContent,
        "box-item": BoxItem,
    },
})
export default class PageTitle extends Vue {
    //初始化视频播放器
    setVideo(playerId: any, url: any, autoplay: boolean, coverImg?: any) {
        //初始化视频
        // @ts-ignore
        var player = new Aliplayer(
            {
                id: playerId,
                width: "100%",
                height: "100%",
                autoplay: autoplay,
                cover: coverImg ? coverImg : undefined,
                source: url,
                isLive: false,
                rePlay: true,
                playsinline: true,
                preload: true,
                controlBarVisibility: "hover",
                useH5Prism: true,
            },
            function (player: any) {
                // console.log("关于ITCP培训模块，视频播放器创建好了。");
            }
        );
    }

    //外部js文件加载完毕钩子
    isLoaded(e: any) {
        // this.setVideo(
        //     "player_1",
        //     "https://ittn.oss-cn-beijing.aliyuncs.com/2021baiqiang/zgc_2022/x23.mp4",
        //     true
        // );
        this.setVideo(
            "player_2",
            "https://ittn.oss-cn-beijing.aliyuncs.com/2021baiqiang/zgc_2022/%E4%B8%AD%E5%85%B3%E6%9D%91.mp4",
            true,
            "https://ittn.oss-cn-beijing.aliyuncs.com/2021baiqiang/zgc_2022/ZGCVideoCover.png"
        );
    }

    get img_src() {
        const base_src =
            "https://ittn.oss-cn-beijing.aliyuncs.com/2021baiqiang/zgc_2022/";
        return this.$i18n.locale == "en"
            ? `${base_src}xjp_en.jpg`
            : `${base_src}xjp_zh.jpg`;
    }

    get img_src_1() {
        const base_src =
            "https://ittn.oss-cn-beijing.aliyuncs.com/2021baiqiang/zgc_2022/";
        return this.$i18n.locale == "en"
            ? `${base_src}history_en.jpg`
            : `${base_src}history_zh.jpg`;
    }
}
